import React from 'react';

import { Tooltip } from '@material-ui/core';

import useTextMaxLength from 'hooks/useTextMaxLength';

interface Props {
  text: string;
  fontSize: number;
  maxChars: number;
}

export default function Text({ fontSize, maxChars, text }: Props) {
  const { needTooltip, newText } = useTextMaxLength(text, fontSize, maxChars);

  if (needTooltip) {
    return (
      <Tooltip title={text} arrow>
        <span>{newText}</span>
      </Tooltip>
    );
  }

  return <span>{text}</span>;
}
